<template>
	<div class="news">
		<div class="printBtn">
			<button class="btn" @click="handleDown2()">打印报告</button>
		</div>
		<div id="demo" v-loading="loading">
			<div class="logo">
				<img :src="baogao" />
			</div>
			<div class="contet">
				<div class="contetTit">
					<h5>企业征信报告(测试模板)</h5>
					<span>{{result.name}}</span>
				</div>
				<div class="catalogue">
					<div class="logue">目录</div>
					<ul>
						<li><strong>一、基本信息</strong> ：企业发展、知识产权、股东信息、主要人员、分支机构信息、对外投资、变更信息</li>
						<li><strong>二、法律诉讼</strong> ：法律诉讼、法院公告、开庭公告、立案信息、被执行人、失信被执行人</li>
						<li><strong>三、企业发展</strong> ：核心团队、融资历程、企业业务、竞品信息、投资机构</li>
						<li><strong>四、知识产权</strong> ：商标信息、软件著作权、专利信息、作品著作权、网站备案</li>
					</ul>
				</div>
			</div>
			<div class="whiteColor" v-show="content">
				<div class="swiperMain">
					<div class="printTit">
						<h5>一、基本信息</h5>
					</div>
					<div class="padding20 licenseInfo">
						<div class="inertit">
							<h5>1.1 营业执照信息</h5>
						</div>
						<ul class="clearfix">
							<li>
								<span>注册资本：</span>
								<span>{{result.regCapital}}</span>
							</li>
							<li>
								<span>成立日期：</span>
								<span>{{result.estiblishTime}}</span>
							</li>
							<li>
								<span>统一社会信用代码：</span>
								<span>{{result.creditCode}}</span>
							</li>
							<li>
								<span>企业名称：</span>
								<span>{{result.name}}</span>
							</li>
							<li>
								<span>公司类型：</span>
								<span>{{result.companyOrgType}} </span>
							</li>
							<li>
								<span>行业：</span>
								<span>{{result.industry}}</span>
							</li>
							<li>
								<span>营业期限：</span>
								<span>{{result.toTime}}</span>
							</li>
							<li>
								<span>核准日期：</span>
								<span>{{result.approvedTime}}</span>
							</li>
							<li>
								<span>登记机关：</span>
								<span>{{result.regInstitute}} </span>
							</li>
							<li>
								<span>经营状态：</span>
								<span>{{result.regStatus}}</span>
							</li>
						</ul>
						<div class="flexBox">
							<span>注册地址：</span>
							<p>{{result.regLocation}}</p>
						</div>
						<div class="flexBox">
							<span>经营范围：</span>
							<P>{{result.businessScope}}</P>
						</div>
					</div>
					<div class="padding20">
						<div class="inertit">
							<h5>1.2 股东信息</h5>
						</div>
						<div class="comTable">
							<comTable :theadTh="shareholder.th" :tbodyTd="shareholder.td"></comTable>
						</div>
					</div>
					<div class="padding20">
						<div class="inertit">
							<h5>1.3 主要人员</h5>
						</div>
						<div class="comTable">
							<comTable :theadTh="mainInfo.th" :tbodyTd="mainInfo.td"></comTable>
						</div>
					</div>
					<div class="padding20">
						<div class="inertit">
							<h5>1.4 分支机构信息</h5>
						</div>
						<div class="comTable">
							<comTable :theadTh="embranchment.th" :tbodyTd="embranchment.td"></comTable>
						</div>
					</div>
					<div class="padding20">
						<div class="inertit">
							<h5>1.5 对外投资</h5>
						</div>
						<div class="comTable">
							<comTable :theadTh="investment.th" :tbodyTd="investment.td"></comTable>
						</div>
					</div>
					<div class="padding20">
						<div class="inertit">
							<h5>1.6 变更信息</h5>
						</div>
						<div class="comTable">
							<comTable :theadTh="changeInfo.th" :tbodyTd="changeInfo.td"></comTable>
						</div>
					</div>
				</div>

				<div v-if="legalRiskVoData">
					<div class="swiperMain">
						<div class="printTit">
							<h5>二、法律诉讼</h5>
						</div>
						<div class="padd40" :model="legalRiskParams">
							<div class="padding20">
								<div class="inertit">
									<h5>2.1 法律诉讼</h5>
								</div>
								<div class="comTable">
									<comTable :paneShow.sync="paneShow" :theadTh="lawsuit.th" :tbodyTd="lawsuit.td"></comTable>
								</div>
							</div>
							<div class="padding20">
								<div class="inertit">
									<h5>2.2 开庭公告</h5>
								</div>
								<div class="comTable">
									<comTable  ref='openNoticeId' :paneShow.sync="paneShow" :theadTh="openNotice.th" :tbodyTd="openNotice.td"></comTable>
								</div>
							</div>
							<div class="padding20">
								<div class="inertit">
									<h5>2.3 法院公告</h5>
								</div>
								<div class="comTable">
									<comTable :paneShow.sync="paneShow" :theadTh="court.th" :tbodyTd="court.td"></comTable>
								</div>
							</div>
							<div class="padding20">
								<div class="inertit">
									<h5>2.4 立案信息</h5>
								</div>
								<div class="comTable">
									<comTable :paneShow.sync="paneShow" :theadTh="register.th" :tbodyTd="register.td"></comTable>
								</div>
							</div>
							<div class="padding20">
								<div class="inertit">
									<h5>2.5 被执行人</h5>
								</div>
								<div class="comTable">
									<comTable :theadTh="executedPerson.th" :tbodyTd="executedPerson.td"></comTable>
								</div>
							</div>
							<div class="padding20">
								<div class="inertit">
									<h5>2.6 失信被执行人</h5>
								</div>
								<div class="comTable">
									<comTable :paneShow.sync="paneShow" :theadTh="letDown.th" :tbodyTd="letDown.td"></comTable>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div v-if="corporateDevelopmentNoData">
					<div class="swiperMain">
						<div class="printTit">
							<h5>三、企业发展</h5>
						</div>
						<div class="padd40" :model="corporateParams">
							<div class="padding20">
								<div class="inertit">
									<h5>3.1 核心团队</h5>
								</div>
								<div class="comTable">
									<comTable :theadTh="coreTeam.th" :tbodyTd="coreTeam.td"></comTable>
								</div>
							</div>
							<div class="padding20">
								<div class="inertit">
									<h5>3.2 融资历程</h5>
								</div>
								<div class="comTable">
									<comTable :theadTh="finance.th" :tbodyTd="finance.td"></comTable>
								</div>
							</div>
							<div class="padding20">
								<div class="inertit">
									<h5>3.3 企业业务</h5>
								</div>
								<div class="comTable">
									<comTable :theadTh="firmBusi.th" :tbodyTd="firmBusi.td"></comTable>
								</div>
							</div>
							<div class="padding20">
								<div class="inertit">
									<h5>3.4 竞品信息</h5>
								</div>
								<div class="comTable">
									<comTable :theadTh="competingInfo.th" :tbodyTd="competingInfo.td"></comTable>
								</div>
							</div>
							<div class="padding20">
								<div class="inertit">
									<h5>3.5 投资机构</h5>
								</div>
								<div class="comTable">
									<comTable :theadTh="investmentOrg.th" :tbodyTd="investmentOrg.td"></comTable>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div v-if="intellectualPropertyNoData">
					<div class="swiperMain">
						<div class="printTit">
							<h5>四、知识产权</h5>
						</div>
						<div class="padd40" :model="intellectualPropertyParams">
							<div class="padding20">
								<div class="inertit">
									<h5>4.1 商标信息</h5>
								</div>
								<div class="comTable">
									<comTable :paneShow.sync="paneShow" :theadTh="trademarkInfo.th" :tbodyTd="trademarkInfo.td"></comTable>
								</div>
							</div>
							<div class="padding20">
								<div class="inertit">
									<h5>4.2 软件著作权</h5>
								</div>
								<div class="comTable">
									<comTable :paneShow.sync="paneShow" :theadTh="softCopyright.th" :tbodyTd="softCopyright.td"></comTable>
								</div>
							</div>
							<div class="padding20">
								<div class="inertit">
									<h5>4.3 专利信息</h5>
								</div>
								<div class="comTable">
									<comTable :paneShow.sync="paneShow" :theadTh="patentInfo.th" :tbodyTd="patentInfo.td"></comTable>
								</div>
							</div>
							<div class="padding20">
								<div class="inertit">
									<h5>4.4 作品著作权</h5>
								</div>
								<div class="comTable">
									<comTable :theadTh="worksCopyright.th" :tbodyTd="worksCopyright.td"></comTable>
								</div>
							</div>
							<div class="padding20">
								<div class="inertit">
									<h5>4.5 网站备案</h5>
								</div>
								<div class="comTable">
									<comTable :theadTh="webRecords.th" :tbodyTd="webRecords.td"></comTable>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
			<!--<div class="bottompic">
				<img :src="baogao" />
			</div>-->
		</div>
		<foot />
		<rightFix />
	</div>
</template>
<script>
import coverImg from '@/assets/img/img10.jpg'
import newsBanner from '@/assets/img/infoBaner1.jpg'
// import innerHd from '@/components/innerHd.vue'
import foot from '@/components/foot.vue'
import rightFix from '@/components/rightFix.vue'
import comTable from '@/components/historyComTable.vue'
// import htmlToPdf from '@/assets/js/htmlToPdf'
import baogao from '@/assets/baogao.png'
export default {
  name: 'enterpriseInfoDetail',
  components: {
    foot,
    rightFix,
    comTable
  },
  data () {
    return {
      // 遮罩层
      loading: true,
      // 是否显示搜索框
      infos: {},
      infos2: {},
      serverBoxShow: false,
      show: false,
      content: true,
      // 详情是否显示
      paneShow: true,
      queryParams: {
        pageNum: 1, // 当前下标
        pageSize: 5 // 每页显示多少条数据
      },
      newsBanner,
      coverImg,
      baogao,
      swiperOption: {
        autoHeight: true
      },
      businessParams: {},
      // 历史信息
      historParams: [],
      // 知识产权
      intellectualPropertyParams: [],
      // 企业发展
      corporateParams: [],
      // 法律诉讼
      legalRiskParams: [],
      result: [],
      // shareholders:[],
      swiperActiveIndex: 0,
      legalRiskVoData: true,
      businessNoData: true,
      corporateDevelopmentNoData: true,
      intellectualPropertyNoData: true,
      // 基础信息
      shareholder: {
        th: [{
          name: '股东（发起人）',
          value: 'name',
          thWidth: '50%'
        }, {
          name: '持股比例',
          value: 'amomon',
          thWidth: '20%'
        }, {
          name: '认缴出资金额',
          value: 'percent',
          thWidth: '25%'
        }],
        td: []
      },
      mainInfo: {
        th: [{
          name: '姓名',
          value: 'name',
          thWidth: '45%'
        }, {
          name: '职位',
          value: 'staffTypeName',
          thWidth: '50%'
        }],
        td: []
      },
      embranchment: {
        th: [{
          name: '企业名称',
          value: 'name',
          thWidth: '40%'
        }, {
          name: '负责人',
          value: 'legalPersonName',
          thWidth: '25%'
        }, {
          name: '成立日期',
          value: 'estiblishTime',
          thWidth: '15%'
        }, {
          name: '经营状态',
          value: 'regStatus',
          thWidth: '15%'
        }],
        td: [name]
      },
      investment: { // 对外投资
        th: [{
          name: '被投资企业名称',
          value: 'name',
          thWidth: '25%'
        }, {
          name: '法定代表人',
          value: 'legalPersonName',
          thWidth: '10%'
        }, {
          name: '成立日期',
          value: 'estiblishTime',
          thWidth: '10%'
        }, {
          name: '投资数额',
          value: 'amount',
          thWidth: '10%'
        }, {
          name: '投资比例',
          value: 'percent',
          thWidth: '10%'
        }, {
          name: '经营状态',
          value: 'regStatus',
          thWidth: '10%'
        }, {
          name: '备注',
          value: 'alias',
          thWidth: '20%'
        }],
        td: []
      },
      // annual: {
      //   th: [{ name: '年报', value: 'reportYear' }],
      //   td: []
      // },
      changeInfo: { // 变更信息
        th: [{
          name: '变更事项',
          value: 'changeItem',
          thWidth: '15%'
        }, {
          name: '变更前内容',
          value: 'contentBefore',
          thWidth: '35%'
        }, {
          name: '变更后内容',
          value: 'contentAfter',
          thWidth: '35%'
        }, {
          name: '变更日期',
          value: 'changeTime',
          thWidth: '10%'
        }],
        td: []
      },

      // 法律诉讼
      lawsuit: {
        th: [{
          name: '发布日期',
          value: 'submittime',
          thWidth: '10%'
        }, {
          name: '案件名称',
          value: 'title',
          thWidth: '30%'
        }, {
          name: '案由',
          value: 'casereason',
          thWidth: '25%'
        }, {
          name: '文书类型',
          value: 'doctype',
          thWidth: '20%'
        }, {
          name: '案号',
          value: 'caseno',
          thWidth: '10%'
        }],
        td: []
      },
      openNotice: { // 开庭公告
        th: [{
          name: '开庭日期',
          value: 'startDate',
          thWidth: '10%'
        }, {
          name: '公诉人/原告/上述人/申请人',
          value: 'plaintiff',
          thWidth: '25%'
        }, {
          name: '案由',
          value: 'caseReason',
          thWidth: '25%'
        }, {
          name: '被告人/被告/被上述人/被申请',
          value: 'defendant',
          thWidth: '25%'
        }, {
          name: '案号',
          value: 'caseNo',
          thWidth: '10%'
        }],
        td: []
      },
      court: { // 法院公告
        th: [{
          name: '刊登日期',
          value: 'publishdate',
          thWidth: '15%'
        }, {
          name: '上述方',
          value: 'party1',
          thWidth: '20%'
        }, {
          name: '被诉方',
          value: 'party2',
          thWidth: '20%'
        }, {
          name: '公告类型',
          value: 'bltntype',
          thWidth: '20%'
        }, {
          name: '法院',
          value: 'courtcode',
          thWidth: '20%'
        }],
        td: []
      },
      register: { // 立案信息
        th: [{
          name: '立案日期',
          value: 'startTime',
          thWidth: '10%'
        }, {
          name: '案由',
          value: 'caseReason',
          thWidth: '17%'
        }, {
          name: '当事人',
          value: 'litigant',
          thWidth: '17%'
        }, {
          name: '原告',
          value: 'plaintiff',
          thWidth: '17%'
        }, {
          name: '被告人',
          value: 'defendant',
          thWidth: '17%'
        }, {
          name: '案号',
          value: 'caseNo',
          thWidth: '17%'
        }],
        td: []
      },
      executedPerson: { // 被执行人
        th: [{
          name: '执行日期',
          value: 'caseCreateTime',
          thWidth: '15%'
        }, {
          name: '案号',
          value: 'caseCode',
          thWidth: '20%'
        }, {
          name: '被执行人',
          value: 'pname',
          thWidth: '25%'
        }, {
          name: '执行法院',
          value: 'execCourtName',
          thWidth: '20%'
        }, {
          name: '执行标',
          value: 'execMoney',
          thWidth: '15%'
        }],
        td: []
      },
      letDown: { // 失信被执行人
        th: [{
          name: '发布日期',
          value: 'publishdate',
          thWidth: '15%'
        }, {
          name: '立案日期',
          value: 'regdate',
          thWidth: '15%'
        }, {
          name: '案号',
          value: 'casecode',
          thWidth: '15%'
        }, {
          name: '执行法院',
          value: 'courtname',
          thWidth: '15%'
        }, {
          name: '履行情况',
          value: 'performance',
          thWidth: '20%'
        }, {
          name: '执行依据文号',
          value: 'gistid',
          thWidth: '15%'
        }],
        td: []
      },
      // 经营状况
      licenseAaum: {
        th: [{
          name: '许可文件号',
          value: 'th1',
          thWidth: '10%'
        }, {
          name: '许可文件名称',
          value: 'th2',
          thWidth: '15%'
        }, {
          name: '许可机关',
          value: 'th2',
          thWidth: '25%'
        }, {
          name: '有效期',
          value: 'th2',
          thWidth: '25%'
        }, {
          name: '许可内容',
          value: 'th2',
          thWidth: '20%'
        }],
        td: []
      },
      licenseCredit: {
        th: [{
          name: '许可文件号',
          value: 'th1',
          thWidth: '25%'
        }, {
          name: '许可机关',
          value: 'th2',
          thWidth: '40%'
        }, {
          name: '许可决定日期',
          value: 'th2',
          thWidth: '30%'
        }],
        td: []
      },
      tax: {
        th: [{
          name: '评级年度',
          value: 'th1',
          thWidth: '15%'
        }, {
          name: '纳税人信用级别',
          value: 'th2',
          thWidth: '20%'
        }, {
          name: '类型',
          value: 'th2',
          thWidth: '20%'
        }, {
          name: '纳税人识别号',
          value: 'th2',
          thWidth: '20%'
        }, {
          name: '评价单位',
          value: 'th2',
          thWidth: '20%'
        }],
        td: []
      },
      sampling: {
        th: [{
          name: '检查实施机关',
          value: 'th1',
          thWidth: '25%'
        }, {
          name: '类型',
          value: 'th2',
          thWidth: '25%'
        }, {
          name: '日期',
          value: 'th2',
          thWidth: '15%'
        }, {
          name: '结果',
          value: 'th2',
          thWidth: '30%'
        }],
        td: []
      },
      // 经营风险
      penaltyAaum: {
        th: [{
          name: '处罚决定日期',
          value: 'th1',
          thWidth: '15%'
        }, {
          name: '决定书文号',
          value: 'th2',
          thWidth: '25%'
        }, {
          name: '决定机关',
          value: 'th2',
          thWidth: '25%'
        }, {
          name: '行政处罚内容',
          value: 'th2',
          thWidth: '30%'
        }],
        td: []
      },
      penaltyCredit: {
        th: [{
          name: '处罚决定日期',
          value: 'th1',
          thWidth: '10%'
        }, {
          name: '决定书文号',
          value: 'th2',
          thWidth: '20%'
        }, {
          name: '处罚是由',
          value: 'th2',
          thWidth: '20%'
        }, {
          name: '处罚机关',
          value: 'th2',
          thWidth: '20%'
        }, {
          name: '行政处罚结果',
          value: 'th2',
          thWidth: '25%'
        }],
        td: []
      },
      equity: {
        th: [{
          name: '登记日期',
          value: 'th1',
          thWidth: '15%'
        }, {
          name: '登记编号',
          value: 'th2',
          thWidth: '15%'
        }, {
          name: '出质人',
          value: 'th2',
          thWidth: '15%'
        }, {
          name: '质权人',
          value: 'th2',
          thWidth: '15%'
        }, {
          name: '状态',
          value: 'th2',
          thWidth: '20%'
        }, {
          name: '出质股权数额',
          value: 'th2',
          thWidth: '15%'
        }],
        td: []
      },
      mort: {
        th: [{
          name: '登记日期',
          value: 'th1',
          thWidth: '15%'
        }, {
          name: '登记编号',
          value: 'th2',
          thWidth: '20%'
        }, {
          name: '被担保债权类型',
          value: 'th2',
          thWidth: '20%'
        }, {
          name: '被担保债权数额',
          value: 'th2',
          thWidth: '20%'
        }, {
          name: '登记机关',
          value: 'th2',
          thWidth: '20%'
        }],
        td: []
      },
      intellectual: {
        th: [{
          name: '公示日期',
          value: 'th1',
          thWidth: '10%'
        }, {
          name: '知识产权登记编号',
          value: 'th2',
          thWidth: '15%'
        }, {
          name: '出质人',
          value: 'th2',
          thWidth: '15%'
        }, {
          name: '质权人',
          value: 'th2',
          thWidth: '20%'
        }, {
          name: '质权登记期限',
          value: 'th2',
          thWidth: '15%'
        }, {
          name: '状态',
          value: 'th2',
          thWidth: '20%'
        }],
        td: []
      },

      // 企业发展
      coreTeam: {
        th: [{
          name: '姓名',
          value: 'name',
          thWidth: '20%'
        }, {
          name: '职位',
          value: 'title',
          thWidth: '25%'
        }, {
          name: '简介',
          value: 'desc',
          thWidth: '50%'
        }],
        td: []
      },
      finance: {
        th: [{
          name: '披露日期',
          value: 'pubTime',
          thWidth: '15%'
        }, {
          name: '交易金额',
          value: 'money',
          thWidth: '15%'
        }, {
          name: '融资轮次',
          value: 'round',
          thWidth: '15%'
        }, {
          name: '估值',
          value: 'value',
          thWidth: '15%'
        }, {
          name: '比例',
          value: 'share',
          thWidth: '15%'
        }, {
          name: '投资商',
          value: 'investorName',
          thWidth: '20%'
        }],
        td: []
      },
      firmBusi: {
        th: [{
          name: '产品名称',
          value: 'product',
          thWidth: '20%'
        }, {
          name: '成立日期',
          value: 'setupDate',
          thWidth: '15%'
        }, {
          name: '行业',
          value: 'hangye',
          thWidth: '20%'
        }, {
          name: '投资时间',
          value: 'setupDate',
          thWidth: '15%'
        }, {
          name: '产品介绍',
          value: 'yewu',
          thWidth: '25%'
        }],
        td: []
      },
      competingInfo: {
        th: [{
          name: '产品名称',
          value: 'product',
          thWidth: '15%'
        }, {
          name: '所属行业',
          value: 'hangye',
          thWidth: '15%'
        }, {
          name: '估值',
          value: 'value',
          thWidth: '10%'
        }, {
          name: '成立日期',
          value: 'date',
          thWidth: '10%'
        }, {
          name: '所属地',
          value: 'location',
          thWidth: '10%'
        }, {
          name: '简介',
          value: 'yewu',
          thWidth: '20%'
        }, {
          name: '所属公司',
          value: 'companyName',
          thWidth: '15%'
        }],
        td: []
      },
      investmentOrg: {
        th: [{
          name: '投资机构',
          value: 'jigouName',
          thWidth: '25%'
        }, {
          name: '成立日期',
          value: 'foundYear',
          thWidth: '20%'
        }, {
          name: '所属地',
          value: 'area',
          thWidth: '20%'
        }, {
          name: '简介',
          value: 'desc',
          thWidth: '30%'
        }],
        td: []
      },
      // 知识产权
      trademarkInfo: {
        th: [{
          name: '商标',
          value: 'tmPic',
          thWidth: '15%'
        }, {
          name: '申请日期',
          value: 'appDate',
          thWidth: '15%'
        }, {
          name: '商标名称',
          value: 'tmName',
          thWidth: '20%'
        }, {
          name: '注册号',
          value: 'regNo',
          thWidth: '15%'
        }, {
          name: '国际分类',
          value: 'tmClass',
          thWidth: '15%'
        }, {
          name: '商标状态',
          value: 'category',
          thWidth: '15%'
        }],
        td: []
      },
      softCopyright: {
        th: [{
          name: '登记批准日期',
          value: 'regTime',
          thWidth: '15%'
        }, {
          name: '软件全称',
          value: 'fullName',
          thWidth: '20%'
        }, {
          name: '软件简称',
          value: 'simpleName',
          thWidth: '20%'
        }, {
          name: '登记号',
          value: 'regNum',
          thWidth: '15%'
        }, {
          name: '分类号',
          value: 'catNum',
          thWidth: '15%'
        }, {
          name: '版本号',
          value: 'version',
          thWidth: '10%'
        }],
        td: []
      },
      patentInfo: {
        th: [{
          name: '申请公布日',
          value: 'applicationPublishTime',
          thWidth: '15%'
        }, {
          name: '专利名称',
          value: 'title',
          thWidth: '20%'
        }, {
          name: '申请号',
          value: 'appNumber',
          thWidth: '20%'
        }, {
          name: '申请公布号',
          value: 'pubNumber',
          thWidth: '20%'
        }, {
          name: '专利类型',
          value: 'patentType',
          thWidth: '20%'
        }],
        td: []
      },
      worksCopyright: {
        th: [{
          name: '作品名称',
          value: 'fullName',
          thWidth: '20%'
        }, {
          name: '登记号',
          value: 'regNum',
          thWidth: '20%'
        }, {
          name: '作品类别',
          value: 'type',
          thWidth: '20%'
        }, {
          name: '创作完成日期',
          value: 'finishTime',
          thWidth: '10%'
        }, {
          name: '登记日期',
          value: 'regTime',
          thWidth: '10%'
        }, {
          name: '首次发表日期',
          value: 'publishTime',
          thWidth: '15%'
        }],
        td: []
      },
      webRecords: {
        th: [{
          name: '审核日期',
          value: 'examineDate',
          thWidth: '15%'
        }, {
          name: '网站名称',
          value: 'webName',
          thWidth: '20%'
        }, {
          name: '网站首页',
          value: 'webSite',
          thWidth: '20%'
        }, {
          name: '域名',
          value: 'ym',
          thWidth: '20%'
        }, {
          name: '网站备案/许可证号',
          value: 'liscense',
          thWidth: '20%'
        }],
        td: []
      },
      padds: []
    }
  },
  created () {
    // this.testIfo()
    this.infos = JSON.parse(this.$route.query.param)
    this.infos2 = JSON.parse(this.$route.query.param2)
    this.getBusinessInfo()
    this.getLegalRisk()
    this.getIntellectualProperty()
    this.getCorporateDevelopment()
    // this.getHistoricalInfo()
  },
  mounted () {},
  computed: {
  },
  methods: {
    test () {
      this.padds.push(this.result, this.corporateParams)
      console.log('全部的值是', this.padds)
    },
    handleDown: function () {
      this.test()
      this.$alert('报告正在生成中，请稍后....')
      // { srcPath: 'http://www.hnhlcredit.com/#/', destPath: this.result.name + '企业征信报告.pdf' }
      this.$api.getwkhtmltopdf(this.infos).then(response => {
        if (response.data === true) {
          this.$alert(response.msg)
        } else {
          this.$alert('报告生成失败')
        }
      })
      // 当前页面 window.location.href
      // https://www.baidu.com/
      // htmlToPdf.downloadPDF(document.querySelector('#demo'), this.result.name+'企业征信报告')
    },
    handleDown2: function () {
      this.$alert('报告正在生成中，请稍后....')
      // window.open('/zx/print/downloadPdf?id=' + this.infos.id + '&name=' + this.infos.name)
      this.$api.downloadPdf(this.infos).then(response => {
        console.log(response)
      })
      // var params = { id: this.infos.id, name: this.infos.name }
      // this.$api.downloadPdf(this.info).then(response => {
      // if (response.data === true) {
      //   this.$alert(response.msg)
      // } else {
      //   this.$alert('报告生成失败')
      // }
      // })
      // 当前页面 window.location.href
      // https://www.baidu.com/
      // htmlToPdf.downloadPDF(document.querySelector('#demo'), this.result.name+'企业征信报告')
    },
    slideFn () {
      this.swiperActiveIndex = this.swiper.activeIndex
    },
    changeIndex (index) {
      this.swiperActiveIndex = index
      this.swiper.slideTo(index, 300, false) // 切换到第一个slide，速度为1秒
    },

    getBusinessInfo () { // 工商信息
      this.loading = true
      this.$api.getBusinessInfo(this.infos).then(response => {
        if (response.code === 200) {
          if (response.data) {
            this.result = response.data
            this.shareholder.td = this.result.shareHolderList
            this.mainInfo.td = this.result.staffList
            this.embranchment.td = this.result.branchList
            this.investment.td = this.result.investList
            // this.annual.td = this.result.reportList
            this.changeInfo.td = this.result.changeList
            this.businessNoData = true
            this.loading = false
          } else {
            this.businessNoData = false
            this.showNodata = true
          }
        } else if (response.code === 401) {
          this.$message('登录状态已过期,请重新登录！')
        }
      })
    },
    getLegalRisk: function () { // 法律诉讼
      this.$api.getLegalRisk(this.infos2).then(response => {
        if (response.data) {
          this.legalRiskParams = response.data
          this.lawsuit.td = this.legalRiskParams.lawSuitList
          this.openNotice.td = this.legalRiskParams.ktAnnouncementList
          this.openNotice.td.forEach(item => {
            console.log('我进来了')
            item.plaintiff.forEach(pval => {
              console.log('信息', pval.name)
            })
            item.defendant.forEach(dval => {
              item.defendant.put(dval.name)
            })
          })
          this.court.td = this.legalRiskParams.courtAnnouncementList
          this.register.td = this.legalRiskParams.courtRegisterList
          this.executedPerson.td = this.legalRiskParams.zhixingList
          this.letDown.td = this.legalRiskParams.dishonestList
          this.legalRiskVoData = true
        } else {
          this.legalRiskVoData = false
          this.showNodata = true
        }
      })
    },
    getCorporateDevelopment: function () { // 企业发展
      this.$api.getCorporateDevelopment(this.infos2).then(response => {
        if (response.data) {
          this.corporateParams = response.data
          this.coreTeam.td = this.corporateParams.teamList
          this.finance.td = this.corporateParams.rongziList
          this.firmBusi.td = this.corporateDevelopcorporateParamsmentParams.productList
          this.competingInfo.td = this.corporateParams.jpList
          this.investmentOrg.td = this.corporateParams.investOrgList
          this.corporateDevelopmentNoData = true
        } else {
          this.corporateDevelopmentNoData = false
          this.showNodata = true
        }
      })
    },
    getIntellectualProperty: function () { // 知识产权
      this.$api.getIntellectualProperty(this.infos2).then(response => {
        if (response.data) {
          this.intellectualPropertyParams = response.data
          this.trademarkInfo.td = this.intellectualPropertyParams.tmList
          if (this.trademarkInfo.td !== null) {
            this.trademarkInfo.td.forEach(item => {
              item.tmPic = "<img style='width:100px;height:100px' src='" + item.tmPic + "'/>"
            })
          }
          this.softCopyright.td = this.intellectualPropertyParams.copyRegList
          this.patentInfo.td = this.intellectualPropertyParams.patentList
          this.worksCopyright.td = this.intellectualPropertyParams.copyRegWorksList
          this.webRecords.td = this.intellectualPropertyParams.icpList
          if (this.webRecords.td !== null) {
            this.webRecords.td.forEach(item => {
              const url = item.webSite.replace(/\["|\"]/g, '')
              item.webSite = "<a style='color:#06c' href='http://" + url + "'>" + url + '</a>'
            })
          }
          this.intellectualPropertyNoData = true
        } else {
          this.intellectualPropertyNoData = false
          this.showNodata = true
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
	#demo {
		background: #fff;
		.logo {
			display: flex;
			align-items: center;
			padding: 0 30px;
			height: 60px;
			border-bottom: 1px solid #ccc;
			img {
				width: 360px;
				height: auto;
			}
		}
		.contetTit {
			text-align: center;
			padding: 80px 0;
			h5 {
				font-size: 32px;
				line-height: 32px;
				font-weight: bold;
				margin-bottom: 10px;
			}
			span {
				font-size: 24px;
				color: #999;
			}
		}
		.catalogue {
			padding: 0 30px 40px;
			.logue {
				font-size: 24px;
				color: #000;
				font-weight: bold;
				margin-bottom: 14px;
			}
			li {
				font-size: 16px;
				color: #666;
				strong {
					color: #000;
					font-weight: bold;
				}
				&:not(:last-child) {
					margin-bottom: 8px;
				}
			}
		}
		.swiperMain {
			padding-bottom: 30px;
		}
		.whiteColor {
			background: #fff;
			padding: 0 30px 30px;
		}
		.padd40 {
			padding: 10px 0 20px;
		}
		.padding20 {
			padding: 18px 0;
		}
		.printTit {
			h5 {
				font-size: 24px;
				color: #000;
				font-weight:bold;
			}
		}
		.inertit{
			padding-bottom:10px;
			h5 {
				font-size: 18px;
				color: #333;
				font-weight:bold;
			}
		}
	}

	.printBtn {
		position: absolute;
		top:10px;
		right:30px;
		.btn {
			width: 100px;
			height: 40px;
			border: none;
			cursor: pointer;
			font-size: 16px;
			color: #fff;
			background: #1E90FF;
		}
	}
</style>
